export class DlsgPolicy {
    'id';
    'name';
    'resourceInclusion';
    'policyPlan';
    'attachedResources';
    'scheduleMode';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceInclusion",
            "baseName": "resourceInclusion",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "policyPlan",
            "baseName": "policyPlan",
            "type": "DlsgPolicyPlan",
            "format": ""
        },
        {
            "name": "attachedResources",
            "baseName": "attachedResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "ScheduleMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DlsgPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
